import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const HealthAlerts = ({ alerts, onDismiss, onViewDetails }) => {
  const getAlertColor = (severity) => {
    switch (severity) {
      case 'critical':
        return 'bg-destructive/10 border-destructive text-destructive';
      case 'warning':
        return 'bg-warning/10 border-warning text-warning';
      case 'info':
        return 'bg-primary/10 border-primary text-primary';
      default:
        return 'bg-muted border-border text-muted-foreground';
    }
  };

  const getAlertIcon = (severity) => {
    switch (severity) {
      case 'critical':
        return 'AlertCircle';
      case 'warning':
        return 'AlertTriangle';
      case 'info':
        return 'Info';
      default:
        return 'Bell';
    }
  };

  if (alerts?.length === 0) {
    return null;
  }

  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-6">
      <div className="flex items-center gap-3 mb-4 md:mb-6">
        <div className="flex items-center justify-center w-10 h-10 md:w-12 md:h-12 bg-warning/10 rounded-lg">
          <Icon name="Bell" size={20} color="var(--color-warning)" />
        </div>
        <div>
          <h2 className="text-lg md:text-xl font-semibold text-foreground">Health Alerts</h2>
          <p className="text-xs md:text-sm text-muted-foreground">Important notifications</p>
        </div>
      </div>
      <div className="space-y-3">
        {alerts?.map((alert) => (
          <div
            key={alert?.id}
            className={`rounded-lg border p-4 ${getAlertColor(alert?.severity)}`}
          >
            <div className="flex items-start gap-3">
              <Icon name={getAlertIcon(alert?.severity)} size={20} className="flex-shrink-0 mt-0.5" />
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold mb-1">{alert?.title}</h3>
                <p className="text-xs md:text-sm opacity-90 mb-3">{alert?.message}</p>
                {alert?.actionRequired && (
                  <p className="text-xs font-medium mb-3">Action Required: {alert?.actionRequired}</p>
                )}
                <div className="flex flex-wrap items-center gap-2">
                  {alert?.actionButton && (
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => onViewDetails(alert)}
                    >
                      {alert?.actionButton}
                    </Button>
                  )}
                  {alert?.dismissible && (
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => onDismiss(alert?.id)}
                    >
                      Dismiss
                    </Button>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HealthAlerts;